import React from 'react'
import Marquee from 'react-fast-marquee'

export default function Slider() {
  return (
    <div className='  slider'>
      <div className='relative z-50 rotate-6 w-[110%]  md:w-[102%] xl:w-[105%] xl:-translate-y-20 md:translate-y-[-4rem]  translate-y-[-5rem] -ml-4  md:ml-[-10px]  xl:ml-[-20px] '>
        <div className='py-5 w-full bg-[#868686]'></div>
        <div className='py-5 w-full bg-[#6cdda3]'></div>
        <Marquee className='bg-[#070324] py-5'>
          <img
            src='/images/logo.png'
            alt='logo'
            width={210}
            height={37}
            className='mr-10'
          />
          <img
            src='/images/logo.png'
            alt='logo'
            width={210}
            height={37}
            className='mr-10'
          />
          <img
            src='/images/logo.png'
            alt='logo'
            width={210}
            height={37}
            className='mr-10'
          />{' '}
          <img
            src='/images/logo.png'
            alt='logo'
            width={210}
            height={37}
            className='mr-10'
          />{' '}
          <img
            src='/images/logo.png'
            alt='logo'
            width={210}
            height={37}
            className='mr-10'
          />
          <img
            src='/images/logo.png'
            alt='logo'
            width={210}
            height={37}
            className='mr-10'
          />
        </Marquee>
      </div>
    </div>
  )
}
